// Base configuration for all environments
const config = {
  development: {
    API_BASE_URL: 'http://localhost:3321/api'
  },
  production: {
    API_BASE_URL: 'https://globe-data.omagad.tech/api' // Empty string for relative paths in production
  },
  test: {
    API_BASE_URL: 'http://localhost:3321/api'
  }
};

// Get current environment, fallback to 'development' if not set
const env = process.env.NODE_ENV || 'development';

// Export the configuration for the current environment
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || config[env].API_BASE_URL;

// Connect (SSO), as the BROWSER reaches it. Baked at build time: set REACT_APP_* before `npm run build`.
export const CONNECT_URL = (process.env.REACT_APP_CONNECT_URL || '').replace(/\/$/, '');
export const CONNECT_CLIENT_ID = process.env.REACT_APP_CONNECT_CLIENT_ID || 'globe-data';

export default {
  API_BASE_URL
};
